import { Spinner as Spin } from '@chakra-ui/react';
import styled from '@emotion/styled';

export interface LoaderProps {
  className?: string;
  large?: boolean;
  fixed?: boolean;
}

const Loader = ({ className }: LoaderProps) => {
  return <Spin className={className} data-test="loader" />;
};

export default styled(Loader)`
  ${({ fixed }) =>
    fixed && {
      width: '32px',
      height: '32px',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, 0)',
    }}
`;
